/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { Ptw100CsoPortalBadGatewayException } from './Ptw100CsoPortalBadGatewayException';
import {
    Ptw100CsoPortalBadGatewayExceptionFromJSON,
    Ptw100CsoPortalBadGatewayExceptionFromJSONTyped,
    Ptw100CsoPortalBadGatewayExceptionToJSON,
} from './Ptw100CsoPortalBadGatewayException';

/**
 * 
 * @export
 * @interface ErrorResponseOfPtw100CsoPortalBadGatewayException
 */
export interface ErrorResponseOfPtw100CsoPortalBadGatewayException {
    /**
     * 
     * @type {number}
     * @memberof ErrorResponseOfPtw100CsoPortalBadGatewayException
     */
    readonly httpStatusCode?: number;
    /**
     * 
     * @type {Ptw100CsoPortalBadGatewayException}
     * @memberof ErrorResponseOfPtw100CsoPortalBadGatewayException
     */
    exception: Ptw100CsoPortalBadGatewayException;
    /**
     * 
     * @type {string}
     * @memberof ErrorResponseOfPtw100CsoPortalBadGatewayException
     */
    $type?: ErrorResponseOfPtw100CsoPortalBadGatewayExceptionTypeEnum;
}


/**
 * @export
 */
export const ErrorResponseOfPtw100CsoPortalBadGatewayExceptionTypeEnum = {
    PtwPtw100WebSharedModelsErrorResponseErrorResponse1PtwPtw100AppZeroApplicationSharedExceptionsPtw100CsoPortalBadGatewayExceptionPtwPtw100AppZeroApplicationSharedPtwPtw100WebShared: 'Ptw.Ptw100.Web.Shared.Models.ErrorResponse.ErrorResponse`1[[Ptw.Ptw100.AppZero.Application.Shared.Exceptions.Ptw100CsoPortalBadGatewayException, Ptw.Ptw100.AppZero.Application.Shared]], Ptw.Ptw100.Web.Shared'
} as const;
export type ErrorResponseOfPtw100CsoPortalBadGatewayExceptionTypeEnum = typeof ErrorResponseOfPtw100CsoPortalBadGatewayExceptionTypeEnum[keyof typeof ErrorResponseOfPtw100CsoPortalBadGatewayExceptionTypeEnum];



/**
 * Check if a given object implements the ErrorResponseOfPtw100CsoPortalBadGatewayException interface.
 */
export function instanceOfErrorResponseOfPtw100CsoPortalBadGatewayException(value?: unknown): value is ErrorResponseOfPtw100CsoPortalBadGatewayException {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(ErrorResponseOfPtw100CsoPortalBadGatewayExceptionTypeEnum)[0];
}

export function ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSON(json: any): ErrorResponseOfPtw100CsoPortalBadGatewayException {
    return ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSONTyped(json, false);
}

export function ErrorResponseOfPtw100CsoPortalBadGatewayExceptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErrorResponseOfPtw100CsoPortalBadGatewayException {
    if (json == null) {
        return json;
    }
    return {
        
        'httpStatusCode': json['httpStatusCode'] == null ? undefined : json['httpStatusCode'],
        'exception': Ptw100CsoPortalBadGatewayExceptionFromJSON(json['exception']),
        '$type': json['$type'] == null ? undefined : json['$type'],
    };
}

export function ErrorResponseOfPtw100CsoPortalBadGatewayExceptionToJSON(value?: Omit<ErrorResponseOfPtw100CsoPortalBadGatewayException, 'httpStatusCode'> | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'exception': Ptw100CsoPortalBadGatewayExceptionToJSON(value['exception']),
        '$type': value['$type'],
    });
}

